module.exports = __webpack_public_path__ + "static/img2-7d3b70831b2fdb965f3ba88793928986.png";